module.exports = __webpack_public_path__ + "static/img/yinliangjian2.eaed05a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/yinliangjian2.png
// module id = bESU
// module chunks = 24